import { render, staticRenderFns } from "./DatepickerComponent.vue?vue&type=template&id=2c871b03&scoped=true&"
import script from "./DatepickerComponent.vue?vue&type=script&lang=js&"
export * from "./DatepickerComponent.vue?vue&type=script&lang=js&"
import style0 from "./DatepickerComponent.vue?vue&type=style&index=0&id=2c871b03&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c871b03",
  null
  
)

export default component.exports